import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const TermsLibraryBasicInfoComponent = ({ termsNameLibrary, sections, onInnerBasicFormChange, selectedTermsLibraries }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer

                    label="Terms Name Library"
                    labelField="Text"
                    list={termsNameLibrary}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'TermsNameLibraryId'

                        );
                    }}
                    optionName='Choose TermsNameLibrary'
                    type="select"
                    value={selectedTermsLibraries?.TermsNameLibraryId}
                    valueField="Value"
                />
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedTermsLibraries?.Name}
                />
                <InputContainer

                    label="Section"
                    labelField="Name"
                    list={sections}
                    onValueChange={(newValue: any) => {
                        const sectionData: any = newValue.map((option: any) => option?.value || '')
                        onInnerBasicFormChange(
                            sectionData,
                            'SectionIds'

                        );
                    }}

                    type="multiselect"
                    value={selectedTermsLibraries?.SectionIds}
                    valueField="Id"
                />
                <InputContainer
                    label="Remarks"
                    name="Remarks"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Remarks'

                        )
                    }}
                    type="text"
                    value={selectedTermsLibraries?.Remarks}
                />
                <div className='col-span-full'>
                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'Description'

                            )
                        }}
                        type="rte"
                        value={selectedTermsLibraries?.Description}
                    />
                </div>


            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default TermsLibraryBasicInfoComponent;
